import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import '../styles/Membres.css';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');

    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    if (password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères.');
      return;
    }

    setLoading(true);
    const { error: updateError } = await supabase.auth.updateUser({
      password: password,
    });
    setLoading(false);

    if (updateError) {
      setError('Erreur lors de la mise à jour : ' + updateError.message);
    } else {
      setMsg('Mot de passe mis à jour avec succès ! Redirection vers la connexion...');
      setTimeout(() => {
        navigate('/connexion');
      }, 2500);
    }
  };

  return (
    <div className="membres-container">
      <h2>Nouveau mot de passe</h2>
      <p style={{ opacity: 0.8, marginBottom: '20px' }}>
        Saisis ton nouveau mot de passe ci-dessous.
      </p>

      <form onSubmit={handleUpdatePassword} className="membres-form">
        <input
          type="password"
          placeholder="Nouveau mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirmer le mot de passe"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        {error && <p className="membres-error">{error}</p>}
        {msg && <p style={{ color: '#28a745', fontSize: '0.9rem', marginTop: '10px' }}>{msg}</p>}

        <button type="submit" className="membres-btn" disabled={loading}>
          {loading ? 'Enregistrement...' : 'Mettre à jour le mot de passe'}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;